// app/javascript/controllers/reminder_delete_controller.js
import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    static values = { url: String, name: String }

    confirmDelete(event) {
        event.preventDefault()

        Swal.fire({
            title: "Delete reminder?",
            text: this.nameValue ? `Remove ${this.nameValue}'s reminder?` : "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            customClass: {
                popup: "swal2-ea-popup",
                confirmButton: "swal2-ea-confirm",
                cancelButton: "swal2-ea-cancel",
                title: "swal2-ea-title"
            },
            buttonsStyling: false
        }).then((result) => {
            if (!result.isConfirmed) return

            fetch(this.urlValue, {
                method: "DELETE",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    "Accept": "text/vnd.turbo-stream.html"
                }
            }).then((res) => {
                if (res.ok) {
                    // Either let Turbo remove the element (if you render turbo_stream)
                    // or just reload the page:
                    window.location.reload()
                } else {
                    throw new Error("Delete failed")
                }
            }).catch(() => {
                Swal.fire({
                    title: "Something went wrong",
                    text: "Please try again.",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false,
                    customClass: { popup: "swal2-ea-popup", title: "swal2-ea-title" }
                })
            })
        })
    }
}